import { defineMessages } from "react-intl";

export const analyticEventOnClick = (
  userID: string,
  listingID: string,
  sectionName: string,
) => {
  if (listingID) {
    window.analyticsIntegrations.trackEvent("Listing section expanded", {
      user_id: userID || "",
      listing_id: listingID,
      section: sectionName,
    });
  }
};

export const surveillanceText = defineMessages({
  has_surveillance: {
    id: "listing.listing_main.has_surveillance",
    defaultMessage: "Security cameras and recording devices",
  },
  surveillance_description: {
    id: "listing.lisitng_main.surveillance_description",
    defaultMessage:
      "Check with your host if there are any surveillance cameras or recording devices in the space.",
  },
});
